var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Formio } from 'formiojs';
import editFormData from './editForm/Products.edit.data';
import editFormValidation from './editForm/Products.edit.validation';
import editFormLayout from './editForm/Products.edit.layout';
import editFormDisplay from './editForm/Products.edit.display';
var Components = Formio.Components;
var FieldComponent = Formio.Components.components.field;
/**
 * Products class extending from a Form.io field base component
 *
 * @author Peter Boersma <@Lycan_gray>
 * @copyright Novti - 2023
 */
var Products = /** @class */ (function (_super) {
    __extends(Products, _super);
    /**
     * Called when the component has been instantiated. This is useful to define
     * default instance variable values.
     *
     * @param component - The JSON representation of the component created.
     * @param options - The global options for the renderer
     * @param data - The contextual data object (model) used for this component.
     */
    function Products(component, options, data) {
        return _super.call(this, component, options, data) || this;
    }
    /**
     * Called immediately after the component has been instantiated to initialize
     * the component.
     */
    Products.prototype.init = function () {
        _super.prototype.init.call(this);
    };
    /**
     * This is the default schema of your custom component. It will "derive"
     * from the base class "schema" and extend it with its default JSON schema
     * properties. The most important are "type" which will be your component
     * type when defining new components.
     *
     * @param extend - This allows classes deriving from this component to
     *                 override the schema of the overridden class.
     *
     * @returns void
     */
    Products.schema = function () {
        var extend = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extend[_i] = arguments[_i];
        }
        return FieldComponent.schema({
            type: 'products',
            label: 'Products',
            key: 'products',
        });
    };
    Object.defineProperty(Products, "builderInfo", {
        /**
         * This is the Form Builder information on how this component should show
         * up within the form builder. The "title" is the label that will be given
         * to the button to drag-and-drop on the buidler. The "icon" is the font awesome
         * icon that will show next to it, the "group" is the component group where
         * this component will show up, and the weight is the position within that
         * group where it will be shown. The "schema" field is used as the default
         * JSON schema of the component when it is dragged onto the form.
         *
         * @returns {Object}
         */
        get: function () {
            return {
                title: 'Products',
                icon: 'fas fa-shopping-cart',
                group: 'basic',
                documentation: '/userguide/#field',
                weight: 0,
                schema: Products.schema()
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Renders the "products" template with a "setValue" callback function bound to the current instance of the class.
     *
     * @param {Array} children - An array of child components or elements to be rendered within the "products" template.
     *
     * @returns {Element} - The rendered "products" template with the "setValue" callback function bound to the current instance of the class.
     */
    Products.prototype.render = function (children) {
        return _super.prototype.render.call(this, this.renderTemplate('products', {
            setValue: this.setValue.bind(this),
            deleteValue: this.deleteValue.bind(this),
        }));
    };
    /**
     * Sets the value of both the data and view of the component (such as setting the
     * <input> value to the correct value of the data.) This is most commonly used
     * externally to set the value and also see that value show up in the view of the
     * component. If you wish to only set the data of the component, like when you are
     * responding to an HTML input event, then updateValue should be used instead since
     * it only sets the data value of the component and not the view.
     *
     * @param value - The value that is being set for this component's data and view.
     * @param flags - Change propogation flags that are being used to control behavior of the
     *                change propogation logic.
     *
     * @returns - Boolean indicating if the setValue changed the value or not.
     */
    Products.prototype.setValue = function (value, flags) {
        if (flags === void 0) { flags = {}; }
        var changed = _super.prototype.setValue.call(this, value, flags);
        // NOTE: Nested value change was not recognized as change, forced update change with updateOnChange(flags, true).
        this.updateOnChange(flags, true);
        return changed;
    };
    /**
     * Checks the validity of this component and sets the error message if it is invalid.
     *
     * @param data
     * @param dirty
     * @param row
     *
     * @returns {boolean}
     */
    Products.prototype.checkComponentValidity = function (data, dirty, row, options) {
        if (options === void 0) { options = {}; }
        // Lets hijack the validation and fail it if our own validation fails.
        if (this.invalid) {
            return false;
        }
        // Otherwise just use the standard validation checker.
        return _super.prototype.checkComponentValidity.call(this, data, dirty, row, options);
    };
    /**
     * Deletes the value of the component.
     *
     * @returns {void}
     */
    Products.prototype.deleteValue = function () {
        var deleted = _super.prototype.deleteValue.call(this);
        // NOTE: Nested value change was not recognized as change, forced update change with updateOnChange(flags, true).
        this.updateOnChange({}, true);
        return deleted;
    };
    return Products;
}(FieldComponent));
export default Products;
Products.editForm = function () {
    return FieldComponent.editForm(__spreadArrays(editFormDisplay, editFormLayout, editFormValidation, editFormData));
};
Components.addComponent('products', Products);
